import React, { useMemo } from "react";
import {
    MobileAppAuthPinDescriptionStyled,
    MobileAppAuthPinDotsContainerStyled,
    MobileAppAuthPinDotStyled,
    MobileAppAuthPinNumbersPanelStyled
} from "./styled/MobileAppAuthPinStyled";
import MobileAppAuthPinNumbersRow from "./MobileAppAuthPinNumbersRow";
import { MOBILE_APP_AUTH_PIN_STATE_INFO } from "./mobileAppAuthPinConstants";
import classnames from "classnames";
import { Button } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import MobileAppAuthPinNumbersButton from "./MobileAppAuthPinNumbersButton";
import { MOBILE_APP_AUTH_STATE } from "../mobileAppAuthConstants";
import useEffectOnce from "../../../../hooks/useEffectOnce";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import MobileAppAuthPinFingerprintBackdrop from "./MobileAppAuthPinFingerprintBackdrop";
import { getAuthVerifyInProgress } from "../../../../modules/LiteTrade/liteTradeSelectors";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { logAppsflyerAction } from "../../../../app/appActions";
import { useLocationProviderContext } from "../../../../providers/LocationProvider/LocationProviderContext";
import Cookies from "universal-cookie";

const browserCookies = new Cookies();

function MobileAppAuthPin(props) {
    const {
        authVerify,
        authVerifyInProgress,
        isPinCodesEqual,
        isPinCodesWrong,
        logAppsflyer,
        onNumClick,
        onPinClear,
        pinCode = '',
        state
    } = props;
    const credentialId = browserCookies.get('credential_id');
    const {getLangPath} = useLangContext();
    const {prevLocation} = useLocationProviderContext();

    useEffectOnce(() => {
        if (credentialId && state === MOBILE_APP_AUTH_STATE.ENTER_PIN) {
            authVerify();
        }
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.LOGIN_PIN_SHOWN,
            payload: { source: prevLocation.pathname || 'None' },
        });
    });

    const {title, description} = MOBILE_APP_AUTH_PIN_STATE_INFO[state] || {};
    const currentPinNumList = useMemo(() => pinCode.split(''), [pinCode]);
    const numDisabled = pinCode.length === 4;

    return <div className="d-flex flex-column h-100 position-relative">
        <div className="flex-1 d-flex flex-column align-items-center justify-content-center">
            <h1 className="mb-0">{getLangPath(title)}</h1>
            <MobileAppAuthPinDescriptionStyled>
                {getLangPath(description)}
            </MobileAppAuthPinDescriptionStyled>
            <MobileAppAuthPinDotsContainerStyled>
                {
                    Array.from({length: 4}).map((item, index) => (
                        <MobileAppAuthPinDotStyled key={index} className={classnames({
                            'increased': (index === currentPinNumList.length - 1) || isPinCodesEqual || isPinCodesWrong,
                            'negative': isPinCodesWrong,
                            'positive': isPinCodesEqual,
                            'selected': !!currentPinNumList[index],
                        })}/>
                    ))
                }
            </MobileAppAuthPinDotsContainerStyled>
        </div>
        <MobileAppAuthPinNumbersPanelStyled>
            <MobileAppAuthPinNumbersRow disabled={numDisabled} numList={[1, 2, 3]} onNumClick={onNumClick}/>
            <MobileAppAuthPinNumbersRow disabled={numDisabled} numList={[4, 5, 6]} onNumClick={onNumClick}/>
            <MobileAppAuthPinNumbersRow disabled={numDisabled} numList={[7, 8, 9]} onNumClick={onNumClick}/>
            <MobileAppAuthPinNumbersRow>
                {
                    state === MOBILE_APP_AUTH_STATE.ENTER_PIN && credentialId
                        ? <Button variant="outline-info">
                            <BinIcon name="IcFingerprint" onClick={authVerify}/>
                        </Button>
                        : <Button variant="outline-info" disabled/>
                }
                <MobileAppAuthPinNumbersButton number={0} onClick={onNumClick}/>
                <Button variant="outline-info" onClick={onPinClear} disabled={!pinCode || numDisabled}>
                    <BinIcon name="IcDelete"/>
                </Button>
            </MobileAppAuthPinNumbersRow>
        </MobileAppAuthPinNumbersPanelStyled>
        {authVerifyInProgress && <MobileAppAuthPinFingerprintBackdrop/>}
    </div>
}

const mapStateToProps = createStructuredSelector({
    authVerifyInProgress: getAuthVerifyInProgress,
});

const mapDispatchToProps = (dispatch) => ({
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppAuthPin);
